// eslint-disable-next-line no-unused-vars
import axios from 'axios'
// eslint-disable-next-line no-unused-vars
import { config, url } from '@/store/index'

const state = () => ({
  tableHeaders: {
    allActive: false,
    headers: [
      {
        title: 'Статус контрагента',
        isSortable: false
      }
    ]
  },
  statuses: [],
  modal: {
    active: false,
    updatedId: null,
    name: '',
    validation: {
      name: { type: null, message: '' }
    }
  },
  pagination: {
    pageList: {
      active: false,
      pages: []
    },
    currentTake: 10,
    currentPage: 1,
    lastPage: 0
  },
  searchValue: '',
  filter: {
    active: false
  },
  isLoading: true,
  responseModal: {
    isActive: false,
    title: '',
    text: '',
    type: ''
  },
  responseModalWithTreaties: {
    isActive: false,
    title: 'Ошибка!',
    text: '',
    type: 'main'
  },
  isActiveDelete: false
})

const getters = {
  getContractorsStatusList: state => state.statuses,
  getContractorsStatusListTableHeaders: state => state.tableHeaders,
  getContractorsStatusListModal: state => state.modal,
  getContractorsStatusListSearchValue: state => state.searchValue,
  getContractorsStatusListFilter: state => state.filter,
  getContractorsStatusListPagination: state => state.pagination,
  getContractorsStatusListIsLoading: state => state.isLoading,
  getContractorsStatusListResponseModal: state => state.responseModal,
  getContractorsStatusListResponseModalWithTreaties: state => state.responseModalWithTreaties,
  getContractorsStatusListActiveDelete: state => state.isActiveDelete
}

const mutations = {
  GET_CONTRACTORS_STATUS: (state, statuses) => {
    state.statuses = statuses.map(status => {
      return {
        ...status,
        isControlsActive: false,
        isActive: false
      }
    })
    state.isLoading = false
  },
  TOGGLE_CONTRACTORS_STATUS_LIST_ITEM_CONTROLS: (state, itemId) => {
    state.statuses.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isControlsActive = !elem.isControlsActive
      } else if (itemId !== elem.id) {
        elem.isControlsActive = false
      }
    })
  },
  TOGGLE_CONTRACTORS_STATUS_LIST_ITEM_ACTIVE: (state, itemId) => {
    const itemsLength = state.statuses.length
    let counter = 0

    state.statuses.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isActive = !elem.isActive
      }
      if (elem.isActive) {
        counter += 1
      }
    })

    counter > 0 ? state.isActiveDelete = true : state.isActiveDelete = false

    state.tableHeaders.allActive = counter === itemsLength
  },
  TOGGLE_CONTRACTORS_STATUS_LIST_ITEM_ACTIVE_ALL: (state) => {
    state.tableHeaders.allActive = !state.tableHeaders.allActive
    state.tableHeaders.allActive ? state.isActiveDelete = true : state.isActiveDelete = false

    state.statuses.forEach((elem) => {
      elem.isActive = state.tableHeaders.allActive
    })
  },
  SHOW_CONTRACTORS_STATUS_LIST_MODAL: (state, itemId) => {
    state.modal.active = true
    if (itemId) {
      const selectedStatus = state.statuses.filter(status => {
        return status.id === itemId
      }).pop()

      state.modal.updatedId = itemId
      state.modal.name = selectedStatus.name
    }
  },
  SET_CONTRACTORS_STATUS_ITEM_NAME: (state, value) => {
    state.modal.name = value
  },
  SET_CONTRACTORS_STATUS_ITEM_FULL_NAME: (state, value) => {
    state.modal.fullName = value
  },
  SET_CONTRACTORS_STATUS_ITEM_VALIDATION: (state, valid) => {
    state.modal.validation.name.message = valid
    state.modal.validation.name.type = 'error'
  },
  CLEAR_CONTRACTORS_STATUS_MODAL_VALIDATION: (state, inputName) => {
    switch (inputName) {
      case 'name':
        state.modal.validation.name = { type: null, message: '' }
        break
      default:
        break
    }
  },
  CLOSE_CONTRACTORS_STATUS_LIST_MODAL: (state) => {
    state.modal.active = false
    state.modal.updatedId = null
    state.modal.name = ''
    state.modal.validation.name = { type: null, message: '' }
  },

  // pagination
  SET_CONTRACTORS_STATUS_LIST_PAGINATION: (state, headers) => {
    state.pagination.currentPage = Number(headers['x-pagination-current-page'])
    state.pagination.lastPage = Number(headers['x-pagination-page-count'])
    // заполняем массив номерами страниц от 1 до последней страницы
    state.pagination.pageList.pages = [...Array(Number(headers['x-pagination-page-count'])).keys()].map(i => ++i)
  },
  RESET_CONTRACTORS_STATUS_LIST_CURRENT_PAGE: (state) => {
    state.pagination.currentPage = 1
  },

  // search
  SET_CONTRACTORS_STATUS_LIST_SEARCH_VALUE: (state, searchValue) => {
    state.searchValue = searchValue
  },

  // filter
  TOGGLE_CONTRACTORS_STATUS_LIST_FILTER: (state) => {
    state.filter.active = !state.filter.active
  },

  // delete checked items
  DELETE_CONTRACTORS_STATUS_LIST_CHECKED_ITEMS_SUCCESS: (state) => {
    state.responseModal.isActive = true
    state.responseModal.title = 'Успех!'
    state.responseModal.text = 'Вы успешно удалили статус(ы)'
    state.responseModal.type = 'main'
  },
  DELETE_CONTRACTORS_STATUS_LIST_CHECKED_ITEMS_ERROR: (state, errorItems) => {
    let listNamesErrorItems = ''
    errorItems.forEach(e => {
      listNamesErrorItems += ` ${e.short_name}`
    })
    state.responseModal.isActive = true
    state.responseModal.title = 'Ошибка!'
    state.responseModal.text = `При удалении статуса произошла ошибка:${listNamesErrorItems}`
    state.responseModal.type = 'main'
  },

  DELETE_CONTRACTORS_STATUS_LIST_CHECKED_ITEMS_TREATIES_ERROR: (state, errorItems) => {
    let listNamesErrorItems = ''
    errorItems.forEach(e => {
      listNamesErrorItems += ` ${e.name}`
    })
    state.responseModalWithTreaties.isActive = true
    state.responseModalWithTreaties.text = `Данные статусы используются в контрагентах:${listNamesErrorItems}`
    state.tableHeaders.allActive = false
  },
  CLOSE_DELETE_CONTRACTORS_STATUS_LIST_MODAL: (state) => {
    state.responseModal.isActive = false
    state.responseModal.title = ''
    state.responseModal.text = ''
    state.responseModal.type = ''
  },
  CLOSE_DELETE_CONTRACTORS_STATUS_LIST_MODAL_WITH_TREATIES: (state) => {
    state.responseModalWithTreaties.isActive = false
    state.responseModalWithTreaties.text = ''
  },
  RESET_CONTRACTORS_STATUS_LIST_ALL_CHECKS: (state) => {
    state.tableHeaders.allActive = false
    state.isActiveDelete = false
    state.statuses.forEach((elem) => {
      elem.isActive = state.tableHeaders.allActive
    })
  },

  // reset store
  RESET_CONTRACTORS_STATUS_LIST_STORE: (state) => {
    state.searchValue = ''
    state.pagination.currentPage = 1
  }
}

const actions = {
  getContractorsStatus ({ commit, state }) {
    const currentTake = state.pagination.currentTake
    const currentPage = state.pagination.currentPage
    const searchFilter = state.searchValue ? `&search[all]=${state.searchValue}` : ''

    axios.get(`${url}/partner-status?expand=partners${searchFilter}&take=${currentTake}&page=${currentPage}`, config).then(response => {
      commit('GET_CONTRACTORS_STATUS', response.data.data)
      commit('SET_CONTRACTORS_STATUS_LIST_PAGINATION', response.headers)
    }).catch(error => {
      console.log('ошибка получения списка контрагентов', error)
    })
  },
  saveContractorsStatusItem ({ commit, state, dispatch }) {
    if (!state.modal.updatedId) {
      const createData = {
        name: state.modal.name
      }
      axios.post(`${url}/partner-status`, createData, config).then(response => {
        commit('CLOSE_CONTRACTORS_STATUS_LIST_MODAL')
        dispatch('getContractorsStatus')
      }).catch(error => {
        commit('SET_CONTRACTORS_STATUS_ITEM_VALIDATION', error.response.data.errors.name[0])
        console.log('Ошибка обновления договора', error.response)
      })
    } else {
      const updateData = {
        name: state.modal.name
      }

      axios.put(`${url}/partner-status/${state.modal.updatedId}`, updateData, config).then(response => {
        commit('CLOSE_CONTRACTORS_STATUS_LIST_MODAL')
        dispatch('getContractorsStatus')
      }).catch(error => {
        commit('SET_CONTRACTORS_STATUS_ITEM_VALIDATION', error.response.data.errors.name[0])
        console.log('Ошибка обновления договора', error.response)
      })
    }
  },
  toggleContractorsStatusListItemControls ({ commit }, itemId) {
    commit('TOGGLE_CONTRACTORS_STATUS_LIST_ITEM_CONTROLS', itemId)
  },
  toggleContractorsStatusListItemActive ({ commit }, itemId) {
    commit('TOGGLE_CONTRACTORS_STATUS_LIST_ITEM_ACTIVE', itemId)
  },
  toggleContractorsStatusListItemActiveAll ({ commit }) {
    commit('TOGGLE_CONTRACTORS_STATUS_LIST_ITEM_ACTIVE_ALL')
  },
  showContractorsStatusModal ({ commit }, itemId) {
    commit('SHOW_CONTRACTORS_STATUS_LIST_MODAL', itemId)
  },
  setContractorsStatusItemName ({ commit }, value) {
    commit('SET_CONTRACTORS_STATUS_ITEM_NAME', value)
  },
  clearContractorsStatusModalValidation ({ commit }, inputName) {
    commit('CLEAR_CONTRACTORS_STATUS_MODAL_VALIDATION', inputName)
  },
  closeContractorsStatusModal ({ commit }) {
    commit('CLOSE_CONTRACTORS_STATUS_LIST_MODAL')
  },
  removeContractorsStatus ({ dispatch }, itemId) {
    axios.delete(`${url}/partner-status/${itemId}`, config).then(response => {
      dispatch('getContractorsStatus')
    }).catch(error => {
      console.log('Ошибка удаления статуса:' + error)
    })
  },

  // pagination
  getContractorsStatusListPage ({ state, commit }, pageNum) {
    const searchFilter = state.searchValue ? `search[all]=${state.searchValue}` : ''
    const currentTake = state.pagination.currentTake
    const currentPage = pageNum

    axios.get(`${url}/partner-status?${searchFilter}&orderBy=id&orderDir=DESC&take=${currentTake}&page=${currentPage}`, config).then(response => {
      commit('GET_CONTRACTORS_STATUS', response.data.data)
      commit('SET_CONTRACTORS_STATUS_LIST_PAGINATION', response.headers)
      commit('CLOSE_CONTRACTORS_STATUS_LIST_PAGE_LIST')
    })
  },
  resetContractorsStatusListCurrentPage ({ commit }) {
    commit('RESET_CONTRACTORS_STATUS_LIST_CURRENT_PAGE')
  },

  // search
  setContractorsStatusListSearchValue ({ commit, dispatch }, searchValue) {
    commit('SET_CONTRACTORS_STATUS_LIST_SEARCH_VALUE', searchValue)
    commit('RESET_CONTRACTORS_STATUS_LIST_CURRENT_PAGE')
    dispatch('getContractorsStatus')
  },

  // delete checked items
  deleteContractorsStatusListCheckedItems ({ commit, state, dispatch }) {
    const checkedItems = []
    const errorItems = []
    const treatiesItems = []

    state.statuses.forEach((e) => {
      if (e.isActive && !!e.partners === false) {
        checkedItems.push(e)
      } else if (e.isActive && e.partners?.length > 0) {
        treatiesItems.push(e)
      }
    })

    if (treatiesItems.length > 0) {
      commit('DELETE_CONTRACTORS_STATUS_LIST_CHECKED_ITEMS_TREATIES_ERROR', treatiesItems)
      commit('RESET_CONTRACTORS_STATUS_LIST_ALL_CHECKS')

      treatiesItems.forEach((e) => {
        e.isActive = false
      })
    }

    async function processMessages (array) {
      for (const item of array) {
        await axios.delete(`${url}/partner-status/${item.id}`, config).then((response) => {
        }).catch(error => {
          errorItems.push(item)
          console.log('Ошибка удаления статуса', error)
        })
      }
    }

    if (checkedItems.length > 0) {
      processMessages(checkedItems).then(() => {
        if (errorItems.length > 0) {
          commit('RESET_CONTRACTORS_STATUS_LIST_ALL_CHECKS')
          commit('DELETE_CONTRACTORS_STATUS_LIST_CHECKED_ITEMS_ERROR', errorItems)
          dispatch('getContractorsStatus')
        } else {
          commit('RESET_CONTRACTORS_STATUS_LIST_ALL_CHECKS')
          commit('DELETE_CONTRACTORS_STATUS_LIST_CHECKED_ITEMS_SUCCESS')
          dispatch('getContractorsStatus')
        }
      })
    }
  },
  closeContractorsStatusListDeleteModal ({ commit }) {
    commit('CLOSE_DELETE_CONTRACTORS_STATUS_LIST_MODAL')
  },
  closeContractorsStatusListDeleteModalWithTreaties ({ commit }) {
    commit('CLOSE_DELETE_CONTRACTORS_STATUS_LIST_MODAL_WITH_TREATIES')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
